import React from 'react'
import PropTypes from 'prop-types'
import { ActorHistoryDetailsView } from './ActorHistoryDetailsView'
import { Definition, Term } from '../common/Details'
import { Box } from '@maui/elements'
import { InfoTooltip } from '../common/Tooltip'

const mergedTooltip = 'UNC groups that were previously suspected to be related and have since been merged into a named group.'
const suspectedTooltip = 'Activity sets that we believe are related to existing groups, but where we do not have enough to attribute the activity with full confidence are tracked under suspected UNC groups. See FAQ for additional detail.'
const noDataAvailable = 'No data available'

function ActorHistoryView({ actorAncestryData, mergedUnc }) {
  if (actorAncestryData === undefined) return null

  if (actorAncestryData === null) {
    return (
      <>
        <Term display='inline-flex'>
          <Box color='colorTextDeemphasis' width='51px' flexBasis='min-content'>Merged Groups</Box>
          <InfoTooltip tooltip={mergedTooltip} ml='spaceGapLarge' />
        </Term>
        <Definition>{noDataAvailable}</Definition>
        <Term display='inline-flex'>
          <Box color='colorTextDeemphasis' width='51px' flexBasis='min-content'>Suspected Groups</Box>
          <InfoTooltip tooltip={suspectedTooltip} ml='spaceGapLarge' />
        </Term>
        <Definition>{noDataAvailable}</Definition>
      </>
    )
  }

  return (
    <>
      <ActorHistoryDetailsView
        list={actorAncestryData.history}
        term='Merged Groups'
        tooltip={mergedTooltip}
        cursor='pointer'
        mergedUnc={mergedUnc}
      />
      <ActorHistoryDetailsView
        list={actorAncestryData.suspectedGroups}
        term='Suspected Groups'
        tooltip={suspectedTooltip}
        cursor='pointer'
      />
    </>
  )
}

ActorHistoryView.propTypes = {
  actorAncestryData: PropTypes.shape({
    history: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })),
    suspectedGroups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })),
  }),
}

export default ActorHistoryView
